module.exports = __webpack_public_path__ + "img/usecase_enterprise_03.dc4049f2.jpg";